(() => {
  function initFaqSection(section) {
    if (!section || section.dataset.faqInitialized === 'true') return;
    section.dataset.faqInitialized = 'true';

    const desktopTabs = Array.from(section.querySelectorAll('.pf-faq__desktop-tabs [data-faq-tab]'));
    const mobileTabs = Array.from(section.querySelectorAll('.pf-faq__mobile-tabs [data-faq-tab]'));
    const allTabButtons = [...desktopTabs, ...mobileTabs];
    const filters = Array.from(section.querySelectorAll('[data-faq-filter]'));
    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    const panelTitle = section.querySelector('[data-faq-panel-title]');
    const productFilters = section.querySelector('[data-faq-product-filters]');
    const mobileActiveLabel = section.querySelector('[data-faq-mobile-active-label]');
    const mobileToggle = section.querySelector('[data-faq-mobile-toggle]');
    const mobileTabList = section.querySelector('[data-faq-mobile-tabs]');
    const emptyState = section.querySelector('[data-faq-empty]');
    const panel = section.querySelector('.pf-faq__panel');

    let activeTab = section.dataset.defaultTab || 'product';
    let activeProductCategory = section.dataset.defaultProductCategory || 'engraved';

    function getTabLabel(tabKey) {
      const button = desktopTabs.find((tab) => tab.dataset.faqTab === tabKey)
        || mobileTabs.find((tab) => tab.dataset.faqTab === tabKey);

      return button ? button.textContent.trim() : tabKey;
    }

    function closeItem(item) {
      item.classList.remove('is-open');
      const button = item.querySelector('[data-faq-question]');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    }

    function renderItems() {
      let visibleCount = 0;

      items.forEach((item) => {
        const itemTab = item.dataset.faqItemTab;
        const itemCategory = item.dataset.faqItemCategory;

        /*
          Product uses the product sub-filter.
          All other main tabs ignore the product category completely.
        */
        const shouldShow = activeTab === 'product'
          ? itemTab === 'product' && itemCategory === activeProductCategory
          : itemTab === activeTab;

        item.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        } else {
          closeItem(item);
        }
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
    }

    function setProductCategory(category) {
      activeProductCategory = category;

      filters.forEach((filter) => {
        const isActive = filter.dataset.faqFilter === category;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (activeTab === 'product') {
        renderItems();
      }
    }

    function updateProductFilterVisibility() {
      if (!productFilters) return;

      const shouldShow = activeTab === 'product';

      productFilters.hidden = !shouldShow;
      productFilters.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

      if (shouldShow) {
        productFilters.style.removeProperty('display');
      } else {
        productFilters.style.setProperty('display', 'none', 'important');
      }
    }

    function setTab(tabKey, shouldScroll = false) {
      activeTab = tabKey;
      const label = getTabLabel(tabKey);

      desktopTabs.forEach((tab) => {
        const isActive = tab.dataset.faqTab === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      mobileTabs.forEach((tab) => {
        tab.hidden = tab.dataset.faqTab === tabKey;
      });

      if (panelTitle) {
        panelTitle.textContent = label;
      }

      if (mobileActiveLabel) {
        mobileActiveLabel.textContent = label;
      }

      /*
        Engraved / License / Portraits / Collars / Leashes
        are visible ONLY on the Product tab.
      */
      updateProductFilterVisibility();

      renderItems();

      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'false');
      }

      if (mobileTabList) {
        mobileTabList.classList.remove('is-collapsed');
      }

      if (shouldScroll && panel && window.matchMedia('(max-width: 749px)').matches) {
        const y = panel.getBoundingClientRect().top + window.scrollY - 88;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    allTabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTab(button.dataset.faqTab, true);
      });
    });

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        if (activeTab !== 'product') return;
        setProductCategory(filter.dataset.faqFilter);
      });
    });

    items.forEach((item) => {
      const button = item.querySelector('[data-faq-question]');
      if (!button) return;

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          if (otherItem !== item && !otherItem.hidden) {
            closeItem(otherItem);
          }
        });

        item.classList.toggle('is-open', !isOpen);
        button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });

    if (mobileToggle && mobileTabList) {
      mobileToggle.addEventListener('click', () => {
        const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
        mobileToggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        mobileTabList.classList.toggle('is-collapsed', !isExpanded);
      });
    }

    setProductCategory(activeProductCategory);
    setTab(activeTab, false);
  }

  function initAllFaqSections(root = document) {
    root.querySelectorAll('[data-pf-faq]').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllFaqSections());
  } else {
    initAllFaqSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-pf-faq]')
      ? event.target
      : event.target.querySelector?.('[data-pf-faq]');

    if (section) {
      section.dataset.faqInitialized = 'false';
      initFaqSection(section);
    }
  });
})();
